import React from 'react';
import {
  Row, Col, Card, CardBody, CardFooter, Input, Button, Form, FormGroup, Alert,
  Container
} from 'reactstrap';
import { saveRole, fetchRole } from '../../../api/Role';
import PageTitle from '../../../components/common/PageTitle';
import { connect } from 'react-redux';
import { SelectAllFeatureList } from '../../../api/Feature';
import Select from 'react-select';
import { LoadingSpinner } from '../../../components';
// import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';
import { fetchRoleFeature } from '../../../api/RoleFeature';
import RoleList from './RoleList';

class NewRole extends React.Component {

  static routeName = '/setup/role-entry';

  constructor(props) {
    super(props);
    this.state = {
      GoToList: false,
      gotolist: false,
      formState: "new",
      errors: [],
      successMessage: '',
      messageVisible: false,
      isLoading: false,
      roleId: this.props.match.params.id,
      roleName: "",
      active: true,
      roleFeatures: [],
      allRoleFeatures: [],
      dropdownData: [],
      feature: { label: "All", values: 0 },
      allFeatures: [],
      data: [],
      filterRoleFeatures: [],
      createdBy: "",
      createdDate: new Date(),
      MGFeatures: [],
      MGforDelete: [],
    }
  }

  async componentDidMount() {
    this.setState({ isLoading: true })
    let { data } = this.state;
    let allFeatures = await SelectAllFeatureList();
    let dropdownData = [{ label: "All", value: "All" }]; // add dropdown options
    let roleFeaturesForMG = [];
    //dropdownbind
    allFeatures.forEach((obj) => {
      if (obj.menuType === "MG") {
        dropdownData.push({ label: obj.menuName, value: obj.menuGroupCode });
        roleFeaturesForMG.push({
          featureId: obj.featureId,
          featureName: obj.menuName,
          MenuGroupCode: obj.menuGroupCode,
          viewPerm: true,
          addPerm: true,
          editPerm: true,
          deletePerm: true,
          otherPerm: 0,
          roleId: 0,
          roleFeatureID: 0,
        })
      }
    });
    allFeatures.forEach(itm => {
      if (itm.menuType === "ME")
        data.push({
          featureId: itm.featureId,
          featureName: itm.menuName,
          MenuGroupCode: itm.menuGroupCode,
          viewPerm: false,
          addPerm: false,
          editPerm: false,
          deletePerm: false,
          otherPerm: 0,
          roleId: 0,
        })
    });
    this.setState({ isLoading: false, allFeatures, dropdownData, data, MGFeatures: roleFeaturesForMG });
    this.loadData();
  }

  async loadData() {
    let { roleId, data , MGFeatures} = this.state;
    if (roleId) {
      this.setState({ isLoading: true });
      const res = await fetchRole(roleId);
      let chkData = await fetchRoleFeature(roleId);
      let createdByForParam = "";
      let createdDateForParam = new Date();
      if (chkData.records.length != 0) {
        createdByForParam = chkData.records[0].createdBy;
        createdDateForParam = chkData.records[0].createdDate;
      }

      if (res) {
        data.forEach(itm => {
          chkData.records.forEach(i => {
            if (itm.featureId === i.featureId) {
              itm.roleFeatureID = i.roleFeatureID;
              itm.roleId = i.roleId;
              itm.viewPerm = i.viewPerm;
              itm.addPerm = i.addPerm;
              itm.editPerm = i.editPerm;
              itm.deletePerm = i.deletePerm;
              itm.otherPerm = i.otherPerm;
            }
          })
        })

        MGFeatures.forEach(itm => {
          chkData.records.forEach(i => {
            if (itm.featureId === i.featureId) {
              itm.roleFeatureID = i.roleFeatureID;
              itm.roleId = i.roleId;
              itm.viewPerm = i.viewPerm;
              itm.addPerm = i.addPerm;
              itm.editPerm = i.editPerm;
              itm.deletePerm = i.deletePerm;
              itm.otherPerm = i.otherPerm;
            }
          })
        })

        this.setState({
          isLoading: false,
          formState: "edit",
          roleId: roleId,
          roleName: res.data.roleName,
          active: res.data.active,
          olddata: data,
          roleFeatures: data,
          allRoleFeatures: data,
          fullData: data,
          createdBy: createdByForParam,
          createdDate: createdDateForParam

        });
      }
    }
    else {
      this.setState({
        formState: "new",
        olddata: data,
        roleFeatures: data,
        fullData: data,
        isLoading: false
      });
    }
  }

  updateState(prop, value) {
    let { fullData } = this.state;
    if (prop === "feature") {
      if (value.value === "All") {
        this.setState({ roleFeatures: fullData });
      } else {
        let selectedItem = fullData.filter((itm) => { if (itm.MenuGroupCode === value.value) { return itm; } });
        this.setState({
          roleFeatures: selectedItem
        });
      }
    }
    this.setState({ [prop]: value });
  }

  resetHandle() {
    this.state.roleFeatures.forEach(row => {
      row.addPerm = false;
      row.viewPerm = false;
      row.editPerm = false;
      row.deletePerm = false;
      row.otherPerm = false;
    })
    this.setState({
      roleId: "",
      code: "",
      roleName: "",
      active: true,
      showParameterButton: false,
    })
  }
  cancelHandle() { this.props.history.push({ pathname: RoleList.routeName }) }

  validate() {
    let errors = [];

    if (this.state.roleName == "") {
      errors.push("* Role Name cannot be blank");
    }
    if (errors.length > 0) {
      this.setState({
        errors,
        messageVisible: true,
        successMessage: '',
        isLoading: false,
      })
      return false;
    } else
      return true;
  }

  async submitHandle() {

    if (this.validate() === false) return;
    this.setState({ isLoading: true });
    const { roleFeatures } = this.state;
    let filteredRoleFeatures = roleFeatures.filter((feature) => feature.viewPerm == true || feature.addPerm == true || feature.editPerm == true || feature.deletePerm == true)
    let MenuGroupCodeName = [];
    let MEfilterLists = this.state.MGFeatures;
    const seenMenuGroupCodes = new Set();

    filteredRoleFeatures.forEach((row,index) => {
      if (!seenMenuGroupCodes.has(row.MenuGroupCode)) { //get MG NAME
        seenMenuGroupCodes.add(row.MenuGroupCode);
        MenuGroupCodeName.push(row.MenuGroupCode);
      }
    });


    MEfilterLists.forEach((feature) => {
      if (MenuGroupCodeName.includes(feature.MenuGroupCode)) { //get associated MG features
        feature.addPerm = true;
        feature.viewPerm = true;
        feature.editPerm = true;
        feature.deletePerm = true;
        filteredRoleFeatures.push(feature);
      } else {
        feature.addPerm = false;
        feature.viewPerm = false;
        feature.editPerm = false;
        feature.deletePerm = false;
        feature.roleId = 0;
      }
    });

    this.state.filterRoleFeatures = filteredRoleFeatures;

    let res = await saveRole(this.state, MEfilterLists);
    if (res === 401) {
      this.setState({ isExpired: true })
    }
    else if (res.status) {
      this.setState({
        errors: [],
        successMessage: "Role has been saved successful.",
        messageVisible: true,
        roleFeatureId: "",
      }, () => this.resetHandle());

      if (this.state.formState === "edit")
        this.props.history.push({ pathname: RoleList.routeName });
    } else {
      this.setState({ errors: [res.message], messageVisible: true, successMessage: "" });
    }

    this.setState({ isLoading: false });
  }

  updateSwitchOfTable = (prop, subProp, index, allValue) => {
    let value = true;
    if (allValue !== undefined) {
      value = allValue;
    } else if (subProp === undefined && index === undefined) // select all 
    {
      value = this.state[prop].filter(obj => (obj.viewPerm || obj.addPerm || obj.editPerm || obj.deletePerm))[0] ? false : true;
      let allCheck = value === false ? false : true;
      this.setState({ allCheck });
    } else if (subProp !== undefined && index === undefined) // select coloumn
    {
      value = this.state[prop].filter(obj => obj[subProp])[0] ? false : true;
      let check = value === false ? false : true;
      this.setState({ subProp: check });
    } else if (subProp === undefined && index !== undefined) // select row
    {
      ['viewPerm', 'addPerm', 'editPerm', 'deletePerm'].map(perm => {
        if (this.state[prop][index][perm] === true) {
          value = false;
          let allRow = false;
          this.setState({ allRow });
        } else {
          let allRow = true;
          this.setState({ allRow });
        }
      });
    }
    this.setState(prevState => ({
      [prop]:
        prevState[prop].map((obj, idx) => {
          if (index === undefined || index === idx) {
            for (var objProp in obj) {
              if (subProp === undefined) {
                switch (objProp) {
                  case 'viewPerm': case 'addPerm': case 'editPerm': case 'deletePerm':
                    obj[objProp] = value;
                }
              } else if (subProp === objProp && index === undefined) {
                obj[objProp] = value;
              } else if (subProp === objProp) {
                obj[objProp] = obj[objProp] ? false : true;
              } else {
                obj[objProp] = obj[objProp]
              }
            }
            return obj;
          } else {
            return obj;
          }
        })
    }));
  }

  renderTable = (roleFeatures) => {
    if (roleFeatures.length <= 0) return <b>No Data To Show</b>;
    return (
      <div className="table-responsive">
        <table className="table table-bordered  table-striped table-hover">
          <thead>
            <tr>
              <th style={{ cursor: 'pointer' }} onClick={() => this.updateSwitchOfTable('roleFeatures')}><span className="btn-link">All</span></th>
              <th>Feature</th>
              <th style={{ cursor: 'pointer' }} onClick={() => this.updateSwitchOfTable('roleFeatures', 'viewPerm')}><span className="btn-link alert-link">View</span></th>
              <th style={{ cursor: 'pointer' }} onClick={() => this.updateSwitchOfTable('roleFeatures', 'addPerm')}><span className="btn-link alert-link">Add</span></th>
              <th style={{ cursor: 'pointer' }} onClick={() => this.updateSwitchOfTable('roleFeatures', 'editPerm')}><span className="btn-link alert-link">Edit</span></th>
              <th style={{ cursor: 'pointer' }} onClick={() => this.updateSwitchOfTable('roleFeatures', 'deletePerm')}><span className="btn-link alert-link">Delete</span></th>
            </tr>
          </thead>
          <tbody>
            {roleFeatures.map((item, idx) =>
              <tr key={idx}>
                <td style={{ cursor: 'pointer' }} onClick={() => this.updateSwitchOfTable('roleFeatures', undefined, idx)} ><span className="btn-link alert-link">{idx + 1}</span></td>
                <td>{item.featureName}</td>
                <td>
                  <input type="checkbox" checked={item.viewPerm} onChange={() => this.updateSwitchOfTable('roleFeatures', 'viewPerm', idx)} />
                </td>
                <td>
                  <input type="checkbox" checked={item.addPerm} onChange={() => this.updateSwitchOfTable('roleFeatures', 'addPerm', idx)} />
                </td>
                <td>
                  <input type="checkbox" checked={item.editPerm} onChange={() => this.updateSwitchOfTable('roleFeatures', 'editPerm', idx)} />
                </td>
                <td>
                  <input type="checkbox" checked={item.deletePerm} onChange={() => this.updateSwitchOfTable('roleFeatures', 'deletePerm', idx)} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    let { roleFeatures, formState } = this.state;
    return (
      <>
        {this.state.isLoading && <LoadingSpinner />}
        {/* <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.BOTTOM_CENTER} /> */}
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            {formState === "new" ?
              <PageTitle sm="4" title="New Role" className="text-sm-left" /> :
              <PageTitle sm="4" title="Edit Role" className="text-sm-left" />
            }
          </Row>
          <Row>
            <Col xs="12" lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <Form onsubmit={(values) => this.submitHandle(values)}>
                    <Row>
                      <Col lg={12}>
                        <FormGroup row>
                          <Col xs={12} sm={6} lg={4} className="d-flex justify-content-end">
                            <label htmlFor="active">Role Name</label>
                          </Col>
                          <Col xs={12} sm={6} lg={4} className="d-flex justify-content-start">
                            <Input className="mb-2" value={this.state.roleName} onChange={(evt) => this.updateState("roleName", evt.target.value)} type="text" id="roleName" name="roleName" placeholder="Enter Role Name.." />
                          </Col>
                        </FormGroup>
                      </Col>
                      <Col lg={12}>
                        <FormGroup row>
                          <Col xs={12} sm={6} lg={4} className="d-flex justify-content-end">
                            <label htmlFor="active">Status</label>
                          </Col>
                          <Col xs={12} sm={6} lg={4} className="d-flex justify-content-start">
                            <Input checked={this.state.active} onChange={(e) => this.updateState("active", e.target.checked)} type="checkbox" id="isActive" name="isActive" className="form-check-input" />
                          </Col>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <fieldset style={{ border: '2px solid lightGrey', padding: '0px 15px', marginBottom: 15 }} >
                          <legend style={{ width: 'auto' }}>&nbsp;Role Feature :&nbsp;</legend>
                          <Row>
                            <Col></Col>
                            <Col>
                              <Select
                                options={this.state.dropdownData}
                                value={this.state.feature}
                                onChange={(value) => this.updateState("feature", value)} />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col>{this.renderTable(roleFeatures)}</Col>
                          </Row>
                          {this.state.errors.length > 0 &&
                            <Alert color="danger" isOpen={this.state.messageVisible} toggle={() => this.setState({ messageVisible: false })}>
                              {this.state.errors.map((msg, index) => (
                                <span key={index}>{msg}<br /></span>
                              ))}
                            </Alert>
                          }
                          {this.state.successMessage !== "" &&
                            <Alert color="success" isOpen={this.state.messageVisible} toggle={() => this.setState({ messageVisible: false })}>
                              <span>{this.state.successMessage}<br /></span>
                            </Alert>
                          }
                        </fieldset>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter>
                  {this.state.formState === "new" &&
                    <Row>
                      <Col>
                        <Button type="reset" theme="info" onClick={() => this.cancelHandle()}  ><i className="fa fa-list-alt"></i> Go To List</Button>
                      </Col>
                      <Col className="d-flex justify-content-end">
                        <Button type="submit" theme="primary" onClick={() => this.submitHandle()} ><i className="fa fa-save"></i> Save</Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button type="reset" theme="danger" onClick={() => this.resetHandle()} ><i className="fa fa-ban"></i> Reset</Button>
                      </Col>
                    </Row>
                  }
                  {this.state.formState === "edit" &&
                    <Row>
                      <Col></Col>
                      <Col className="d-flex justify-content-end">
                        <Button type="submit" size="sm" theme="primary" onClick={() => this.submitHandle()} ><i className="fa fa-dot-circle-o"></i> Update</Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button type="reset" size="sm" theme="danger" onClick={() => this.cancelHandle()} ><i className="fa fa-ban"></i> Cancel</Button>
                      </Col>
                    </Row>
                  }
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
function mapStateToProps(state) {
  return { auth: state.auth };
}
export default connect(mapStateToProps)(NewRole);
